var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "addRepNuera",
      "centered": "",
      "size": "md",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "hide-header-close": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "headergroup"
        }, [_c('div', {
          staticClass: "addRep-header"
        }, [!_vm.showOtpModal ? _c('h4', {
          staticClass: "text-center"
        }, [_vm._v("Add Rep User")]) : _vm._e()]), _c('div', {
          staticClass: "otpmodalheader"
        }, [_vm.showOtpModal ? _c('h4', {
          staticClass: "text-center mb-3"
        }, [_vm._v(" Validate " + _vm._s(_vm.otpType) + " via OTP")]) : _vm._e()])]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn",
            "id": "crossbtn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    staticClass: "px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "addRep-form"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [!_vm.showOtpModal ? _c('form', {
          ref: "addRepAdminContainer",
          on: {
            "submit": function submit($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.create);
            }
          }
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: true,
              email: true
            },
            "labelFor": "email",
            "labelName": "Email Address",
            "vmodel": _vm.form.email,
            "formGroupClass": "form-group",
            "inputType": "email"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "email", $event);
            }
          }
        }), _c('div', {
          staticClass: " row justify-content-between validation-row mt-2 mb-1",
          class: _vm.showOtpSectionEmail ? 'rep-otp-validation mb-3' : 'mb-1',
          attrs: {
            "id": "emailOTP"
          }
        }, [_vm.showOtpSectionEmail ? _c('a', {
          staticClass: "validate-via-otp-link validate-btn",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.sendOtp('email');
            }
          }
        }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL. ")]) : _vm._e()]), _vm.emailMsg ? _c('div', {
          staticClass: "contacts-message-container form-group"
        }, [_c('div', {
          class: ['validate-message', _vm.emailValidationMessage.type]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.emailValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.emailValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.emailValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.emailValidationMessage.message) + " ")])])]) : _vm._e(), _c('input-text', {
          attrs: {
            "rules": {
              required: true,
              digits: 10
            },
            "labelFor": "phone",
            "labelName": "Phone",
            "vmodel": _vm.form.phone,
            "formGroupClass": "form-group mt-2",
            "inputType": "number",
            "maxlength": "10",
            "inputmode": "numeric",
            "pattern": "\\d*"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "phone", $event);
            }
          },
          nativeOn: {
            "keypress": function keypress($event) {
              return _vm.onlyAllowDigits.apply(null, arguments);
            }
          }
        }), _c('div', {
          staticClass: " row justify-content-between validation-row mt-2 mb-1",
          class: _vm.showOtpSectionPhone ? 'rep-otp-validation mb-3' : 'mb-1',
          attrs: {
            "id": "phoneOTP"
          }
        }, [_vm.showOtpSectionPhone ? _c('a', {
          staticClass: "validate-via-otp-link validate-btn ",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.sendOtp('phone');
            }
          }
        }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE. ")]) : _vm._e()]), _vm.phoneMsg ? _c('div', {
          staticClass: "contacts-message-container form-group"
        }, [_c('div', {
          class: ['validate-message', _vm.phoneValidationMessage.type]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.phoneValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.phoneValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.phoneValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.phoneValidationMessage.message) + " ")])])]) : _vm._e(), _c('div', {
          staticClass: "form-group text-center mb-3 mt-3"
        }, [_c('b-button', {
          staticClass: "univ-btn",
          attrs: {
            "type": "submit",
            "disabled": !_vm.form.email || !_vm.form.phone
          }
        }, [_vm._v(" " + _vm._s(_vm.isCreate ? "Creating..." : "Create") + " ")])], 1)], 1) : _vm._e(), _vm.showOtpModal ? _c('div', {
          staticClass: "otp-verification-section"
        }, [_c('div', {
          staticClass: "rep-admin-otp-container "
        }, [!_vm.verificationSkipped ? _c('div', [_c('div', {
          staticClass: "otp-modal-content"
        }, [_c('h6', [_vm._v("Verify OTP")]), _c('p', {
          staticClass: "text-muted mb-2"
        }, [_vm._v(" Validate your " + _vm._s(_vm.otpType) + " via OTP "), _c('br'), _vm._v(" OTP has been sent to "), _c('strong', {
          staticStyle: {
            "word-wrap": "break-word"
          }
        }, [_vm._v(_vm._s(_vm.contactInfo))])]), _c('div', [_c('label', {
          staticClass: "mb-2 mt-3",
          attrs: {
            "id": "enterotplabel"
          }
        }, [_vm._v("Please enter the 6 digit OTP:")]), _c('div', {
          staticClass: "d-flex mb-3 otp-inputs-wrapper align-items-center gap-2"
        }, _vm._l(_vm.otpDigits, function (digit, index) {
          return _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model.number",
              value: _vm.otpDigits[index],
              expression: "otpDigits[index]",
              modifiers: {
                "number": true
              }
            }],
            key: index,
            ref: "otpInputs",
            refInFor: true,
            staticClass: "form-control otp-input",
            attrs: {
              "maxlength": "1",
              "min": "0",
              "max": "9",
              "disabled": _vm.otpVerified,
              "inputmode": "numeric",
              "pattern": "\\d*"
            },
            domProps: {
              "value": _vm.otpDigits[index]
            },
            on: {
              "input": [function ($event) {
                if ($event.target.composing) { return; }

                _vm.$set(_vm.otpDigits, index, _vm._n($event.target.value));
              }, function ($event) {
                return _vm.handleOtpInput(index, $event);
              }],
              "keydown": [function ($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
                return _vm.handleOtpDelete(index, $event);
              }, function ($event) {
                return _vm.preventNonNumeric($event);
              }],
              "paste": function paste($event) {
                return _vm.handlePaste($event);
              },
              "blur": function blur($event) {
                return _vm.$forceUpdate();
              }
            }
          });
        }), 0)]), _c('div', {
          staticClass: "d-flex mt-4 gap-2 flex-wrap justify-content-center"
        }, [_c('b-button', {
          staticClass: "univ-btn verify-btn m-0",
          attrs: {
            "id": "verifyotpbtn",
            "disabled": !_vm.isOtpComplete || _vm.otpVerificationInProgress || _vm.otpVerified
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.verifyOtp.apply(null, arguments);
            }
          }
        }, [_vm.otpVerificationInProgress ? _c('span', [_vm._v("Verifying...")]) : _vm.otpVerified ? _c('span', [_vm._v("Verified")]) : _c('span', [_vm._v("Verify OTP")])])], 1), _vm.otpValidationMessage && _vm.otpAttempted ? _c('div', {
          staticClass: "otp-message-container"
        }, [_c('div', {
          class: ['validate-message', _vm.otpValidationMessage.type],
          staticStyle: {
            "margin-top": "1rem"
          }
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.otpValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.otpValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.otpValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.otpValidationMessage.message) + " ")])])]) : _vm._e()])]) : _vm._e()]), _c('div', {
          staticClass: "button-group mt-3 d-flex justify-content-center align-items-center  gap-3"
        }, [_c('b-button', {
          staticClass: "btn btn-secondary cancel-btn mt-0",
          on: {
            "click": _vm.showOriginalModal
          }
        }, [_vm._v(" Cancel ")]), _c('b-button', {
          staticClass: "univ-btn mt-0",
          attrs: {
            "id": "saveChangesBtn",
            "disabled": !_vm.canSaveChanges
          },
          on: {
            "click": _vm.saveChanges
          }
        }, [_vm._v(" Save changes ")])], 1)]) : _vm._e()];
      }
    }])
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }